module.exports = __webpack_public_path__ + "img/20200609_132445.9cefeba5.jpg";